import styled from 'styled-components';
import P from './P';

/**
 * @deprecated use gen.2 Typography instead
 */
const B = styled(P)`
  font-weight: bold;
`;

export default B;
